/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const d = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g, t = ":not(.k-dropdownlist button):not(.k-colorpicker button):not(.k-numerictextbox button):not(.k-split-button .k-split-button-arrow)", o = ":not(.k-dropdownlist select)", n = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled]):not(.k-dropdownlist select)",
  "textarea:not([disabled])",
  `button:not([disabled])${t}`,
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], s = [...n, `[tabindex]${t}${o}`], i = [...n, `[tabindex]${t}${o}`].map((e) => e + ':not([tabindex="-1"])');
export {
  d as FIELD_REGEX,
  s as FOCUSABLE_ELEMENTS,
  n as FOCUSABLE_ELEMENTS_BASE,
  i as TABBABLE_ELEMENTS
};
